import styled from "styled-components";
import { COLORS } from "../../../../values/colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    gap: 3rem;
    padding-top: 5rem;
    padding-bottom: 5rem;
    @media (max-width: 1050px) {
        padding-top: 3rem;
        margin-top: 2rem;
    }
    `;

export const TopicContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center; 
    justify-content: center;
    gap: 1rem;
`;

export const CheckIconRounded = styled.div`
    background-color: white;
    border-radius: 50%;
    padding: 1rem;
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 620px) {
        width: 1.5rem;
        height: 1.5rem;
    }
`;

export const TopicTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 0.5rem;
`;

export const TextMessageContainer = styled.div`
    background-color: ${COLORS.gray};
    width: 35%;
    padding: 2rem;
    padding-bottom: 2.5rem;
    border-radius: 1.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
    @media(max-width: 1200px){
        width: 70%;
    }
`;

export const Heading = styled('h1')`
    font-size: 2rem;
    color: white;
    margin:0;
    @media(max-width: 620px){
        font-size: 1.3rem;
    }
`;

export const SmallerHeading = styled('h3')`
    font-size: 1.5rem;
    color:white;
    @media(max-width: 620px){
        font-size: 1.1rem;
    }
`;

export const SecondaryText = styled('p')`
    font-size: 1.1rem;
    margin: 0;
    color: ${COLORS.textSecondary};
`;